module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "txc",
    attrs: {
      "id": "d6e1566"
    }
  }, [_vm._v("For all the people who told me they loved Tejada"), _c('br'), _vm._v("and wanted me to reform him,"), _c('br'), _vm._v("and all the people who hated Tejada"), _c('br'), _vm._v("and begged me to kill him off in the last book.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c49dd1f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pawe_9781569477786_epub_c6_r1.vue
// module id = 72
// module chunks = 0